import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

const PhoneNumber = ({ phone }) => <a href={`tel:${phone}`}>{phone}</a>;
const ExternalLink = ({ href }) => <a href={href} target="_blank" rel="noreferrer noopener">{href}</a>;

class PropertyOverview extends React.Component {
  render() {
    const hotel = this.props.hotel;
    return (
      <div className="col-md-6">
        <h4>{hotel.name} <Button onClick={this.props.handleEdit}>Edit</Button></h4>
        <h4>{hotel.address}</h4>
        <h4>{hotel.locality}, {hotel.region}, {hotel.postcode}</h4>
        <h4><PhoneNumber phone={hotel.tel} /></h4>
        <h4 className="wrap-text"><ExternalLink href={hotel.website} /></h4>
      </div>
    );
  }
}
PropertyOverview.propTypes = {
  hotel: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
};
export default PropertyOverview;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyOverview.js